import { AccountSettings, Authenticator, Button, CheckboxField, Flex, Image, useAuthenticator, useTheme, translations } from '@aws-amplify/ui-react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Branding, theme } from '../../branding';
import RedirectPage from '../../pages/RedirectPage/RedirectPage';
import AppSnackbar from '../Snackbar/Snackbar';
import SpinnerPage from '../SpinnerPage/SpinnerPage';
import WaitingRoom from '../WaitingRoom/WaitingRoom';
import { verifyActivationCode } from './helpers/activationTokenHelper';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { getOffice365Clients, getSkywardClients } from '../../common/service';
import Footer from "../Footer/Footer";
import { CircularProgress, Divider, Box } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { useMediaQuery } from 'react-responsive';
import { EmployersOptions } from './EmployersOption';
import awsconfig from "./../../aws-exports";


const config = require("Config");




const useStyles = makeStyles((theme) => ({
	rootGrid: {
		marginTop: theme.spacing(10),
		paddingBottom: theme.spacing(3),
	},
	rootGridMobile: {
		marginTop: theme.spacing(0),
		paddingBottom: theme.spacing(3),
	},
	grid: {
		justifyContent: 'center',
		direction: "row"
	},
	box: {
		width: '90%',
		maxWidth: 650,
	},
	card: {
		justifyContent: 'center',
		paddingBottom: "16px",
		paddingTop: "16px",
		elevation: 0
	},
	cardMedia: {
		width: 138,
		height: 40.25,
		backgroundSize: 'contain',
	},
	cardHeader: {
		paddingBottom: 0
	},
	cardContent: {
		"&:last-child": {
			paddingBottom: theme.spacing(1)
		}
	},
	divider: {
		marginBottom: theme.spacing(2)
	},
	typoToS: {
		paddingTop: theme.spacing(3),

	},
	linkTos: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.newSecondary,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.linkHover,
			opacity: Branding.opacityHover,
		},
	},
	link: {
		fontSize: 14,
		fontWeight: "bold",
		fontFamily: 'Roboto, sans-serif',
		color: Branding.link,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.linkHover,
			opacity: Branding.opacityHover,
		},
	},
	contactSupportLink: {
		fontSize: 14,
	},
	midBul: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		color: Branding.secondary,
	},
	linkImprint: {
		fontSize: 14,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	subTitle: {
		fontSize: 14,
		fontWeight: "bold",
		color: Branding.lightBlack
	},
	socialPx: {
		minWidth: "20em"
	},
	message: {
		fontWeight: 'bold',
		marginTop: "2em",
		fontSize: "12px",
		color: Branding.primary
	},
	socialIconsRoot: {
		justifyContent: 'center',
		textAlign: "center"
	},
	socialIconButtons: { width: "60px", height: "80px", cursor: "pointer" },
	socialIconImages: { width: "60px", height: "85px" },
	// socialIconButtons: { borderStyle: "ridge", width: "60px", height: "60px", margin: "0px", backgroundColor: "white", borderRadius: "8px", borderColor: "#D7D7D7", borderWidth: "1px", paddingTop: "8px" },
	socialIconLable: { fontSize: "12px" },
	headerText: {
		fontSize: "34px",
		marginTop: "15px",
		fontWeight: 700
	},
	helpTextHeaderText: {
		display: 'flex',
		alignItems: 'center',
		fontSize: "20px",
		marginTop: "15px",
		fontWeight: 700,
		letterSpacing: "0.25px"
	},
	helpTextDescriptionText: {
		fontSize: "14px"
	},
	dividerContainer: {
		marginTop: "24px",
		marginBottom: "24px"
	},
	rootContainer: {
		fontFamily: 'Roboto, sans-serif !important'
	},
	passwordError: {
		color: "rgba(211, 47, 47, 1)"
	},
	passwordSuccess: {
		color: "rgba(46, 125, 50, 1)",
	},
	emailError: {
		color: "#B33333"
	},
	emailSuccess: {
		color: "#11ce66"
	},
	passwordSuggestions: {
		fontSize: "14px"
	},
	helpIcon: {
		color: '#000000',
		opacity: '0.54',
		height: '20px',
		with: '20px',
	},
	validationBox: {
		fontSize: '12px',
		color: 'rgba(0, 0, 0, 0.6)',
		position: 'relative',
		top: '-0.75em'
	},
	employerViewSideHeading: {
		fontSize: "20px",
		fontWeight: "bold",
		fontFamily: 'Roboto, sans-serif',
		fontWeight: '700'
	},
	checkIconWithText: {
		display: 'flex',
		alignItems: 'center',
		padding: '0.4rem',
		gap: '8px'
	},
	employerViewSideHeadingText: {
		fontSize: "14px",
		fontWeight: '400',
		fontFamily: 'Roboto, sans-serif',
	},
	empBaseText: {
		lineHeight: '130%',
		letterSpacing: '0.035px',
		marginTop: "0.5em",
		marginBottom: "1.25em",
	},
	employerSigninContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		marginTop: "1.5em",
	},
	horizontalDivider: {
		flexGrow: 1,
	},
	headingText: {
		fontFamily: 'Roboto, sans-serif',
		margin: `0 ${theme.spacing(1)}px`,
		color: theme.palette.text.secondary,
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: '130%',
		letterSpacing: '0.035px'
	},
}));

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
		user: state.app.user,
		tos: state.app.tos
	}
}

const SignInContainer = (props) => {
	const classes = useStyles();
	const [isLoading, setIsLoading] = React.useState(false);
	const [showWaitingRoom, setShowWaitingRoom] = React.useState(false);
	const [changePasswordSuccess, setChangePasswordSuccess] = React.useState(null);
	const [isProviderLogin, setProviderLogin] = React.useState(false);
	const location = useLocation();
	const { error, route, user } = useAuthenticator((context) => [context.route, context.user, context.error, context.toSignIn]);
	const isToSAgreed = useRef(false);
	const [snackBarOps, setSnackBarOps] = React.useState({});
	const [toggleSearchInputBox, setToggleSearchInputBox] = useState(false);
	const [toggleSkywardSearchInputBox, setToggleSkywardSearchInputBox] = useState(false);
	const [isOffice365Loading, setIsOffice365Loading] = useState(false);
	const [isSkywardLoading, setIsSkywardLoading] = useState(false);
	const [office365Clients, setOffice365Clients] = useState(null);
	const [skywardClients, setSkywardClients] = useState(null);
	const [employerView, setEmployerView] = useState(false);
	const isEmployerView = useRef(false);
	const MobileView = useMediaQuery({ query: '(max-width: 600px)' });
	const navigate = useNavigate();
	let queryStringParams = new URLSearchParams(
		decodeURIComponent(window.location.search)
	);
	let signup_email = '';
	let decryptedCode = null;
	let decryptedData = null;
	let signInForm;
	let signUpForm;

	const getFormElements = () => {
		let elements = document.getElementsByTagName("form");
		if (elements.length > 0) {
			for (const attr of elements[0].attributes) {
				if (attr.name.includes("authenticator-signin")) {
					signInForm = elements[0];
				} else if (attr.name.includes("authenticator-signup")) {
					signUpForm = elements[0];
				}
			}
		}
		return;
	}
	if (queryStringParams.get("inviteCode")) {
		try {
			decryptedCode = JSON.parse(atob(queryStringParams.get("inviteCode")));
			sessionStorage.removeItem("inviteCode");
		} catch (e) {
			console.error(e);
		}
	}
	const formFields = {
		signUp: {
			email: {
				isRequired: true,
				type: "email",
				onBlur: (e) => {
					signup_email = e.target.value;
				}
			},
			password: {
				placeholder: 'Create your password',
				label: 'Create password',
			},
			confirm_password: {
				label: 'Repeat password',
				placeholder: "Repeat your password"
			},
			"custom:alternate_email": {
				type: "email",
				label: 'Alternate Email (optional)',
				placeholder: 'Enter your Alternate Email',
				title: "In case you lose access to your primary email, you can use your secondary email to retrieve your login information"
			}
		}
	};

	if (decryptedCode?.email) {
		signup_email = decryptedCode?.email;
		formFields.signUp.email = {
			defaultValue: decryptedCode.email,
			isReadOnly: true,
			style: {
				background: "hsl(210 5% 94% / 1)",
				border: "#00000000",
				cursor: "no-drop",
				color: "hsl(210 10% 58% / 1)"
			},
		}
	}
	if (decryptedCode?.redirectUrl)
		sessionStorage.setItem("redirectUrl", decryptedCode.redirectUrl)

	// SAML
	const oidcProviders = (config.providers && config.providers.sort());
	var ordering = {}, // map for efficient lookup of sortIndex
		sortOrder = ['Clever', 'ClassLink', 'Google', 'Office365', 'GADOE', 'GG4L', 'Skyward'];
	for (var i = 0; i < sortOrder.length; i++)
		ordering[sortOrder[i]] = i;

	oidcProviders.sort(function (a, b) {
		return (ordering[a] - ordering[b]);
	});

	const toggleSignInSignUpButtonText = () => {
		setTimeout(() => {
			if (signInForm)
				for (var i = 0; i < signInForm.elements.length; i++) {
					var element = signInForm.elements[i];
					if (element.type === "submit") {
						if (element.innerText == "Signing in") return;
						if (isEmployerView.current)
							element.innerHTML = "Log in as employer";
						else if (element.innerText != "Login with email") {
							element.innerHTML = "Login with email";
						}
					}
				}

			if (!signUpForm) return;
			for (var i = 0; i < signUpForm.elements.length; i++) {
				var element = signUpForm.elements[i];
				if (element.type === "submit") {
					if (element.innerText == "Creating Account") return;
					if (isEmployerView.current)
						element.innerHTML = "Sign up as employer";
					else if (element.innerText != "Sign up with email")
						element.innerHTML = "Sign up with email";
				}
			}
		}, 500);
	}

	const toggleEmployerView = () => {
		isEmployerView.current = !employerView;
		setEmployerView(!employerView);
		getFormElements();
		toggleSignInSignUpButtonText();
	}

	const checkIfMetaData = (updateEmployerView) => {
		if (queryStringParams.get('data') || sessionStorage.getItem("data")) {
			let data = queryStringParams.get('data') || sessionStorage.getItem("data");
			try {
				const params = JSON.parse(atob(data));
				if (params && params?.origin?.toLowerCase() === 'employer') {
					const employersData = { ...params, ...{ origin: params?.origin.toLowerCase() } };
					decryptedData = JSON.stringify(employersData);
					if (updateEmployerView)
						toggleEmployerView();
				}
			} catch (error) {
				console.error(error);
			}
		} else if (isEmployerView.current) {
			decryptedData = JSON.stringify({ origin: 'employer' });
		}
	}



	const generateOIDCButtons = (providers) => {
		return oidcProviders.map(IdP => {
			if (IdP === "Google" && providers.indexOf("Google") != -1)
				return (<div onClick={async () => await handleIdPLogin(IdP)} key={IdP} className={classes.socialIconButtons}>
					<Image
						src="https://cdn.youscience.com/public/isp/social_icons/google.png"
						ariaLabel=""
						className={classes.socialIconImages}
					/>
				</div>)
			if (!employerView && IdP === "ClassLink" && providers.indexOf("ClassLink") != -1)
				return (<div key={IdP} onClick={async () => await handleIdPLogin(IdP)} className={classes.socialIconButtons}>
					<Image
						src="https://cdn.youscience.com/public/isp/social_icons/classlink.png"
						ariaLabel=""
						className={classes.socialIconImages}
					/>
				</div>)
			if (!employerView && IdP === "Clever" && providers.indexOf("Clever") != -1)
				return (<div key={IdP} onClick={async () => await handleIdPLogin(IdP)} className={classes.socialIconButtons}>
					<Image
						src="https://cdn.youscience.com/public/isp/social_icons/clever.png"
						ariaLabel=""
						className={classes.socialIconImages}
					/>
				</div>)
			if (!employerView && IdP === "Office365" && providers.indexOf("Office365") != -1)
				return (<div key={IdP} onClick={async () => {
					if (awsconfig.waitingRoomEnabled) {
						await handleIdpLoginActionDoNothing('Office365');
					}

					if (!office365Clients) {
						setIsOffice365Loading(true);
						setOffice365Clients(await getOffice365Clients());
						setIsOffice365Loading(false);
					}
					setToggleSearchInputBox(!toggleSearchInputBox)
				}} className={classes.socialIconButtons}>
					{!isOffice365Loading ?
						<Image
							src="https://cdn.youscience.com/public/isp/social_icons/microsoft.png"
							ariaLabel=""
							className={classes.socialIconImages}
						/> : <Button
							key={"Office365Btn"}
							style={{ borderRadius: 10, border: 0, height: "80%" }}
							isFullWidth="true"
							isLoading={isOffice365Loading}
						></Button>}

				</div>)
			if (!employerView && IdP === "Skyward" && providers.indexOf("Skyward") != -1)
				return (<div key={IdP} onClick={async () => {
					if (awsconfig.waitingRoomEnabled) {
						await handleIdpLoginActionDoNothing('Skyward');
					}

					if (!skywardClients) {
						setIsSkywardLoading(true);
						setSkywardClients(await getSkywardClients());
						setIsSkywardLoading(false);
					}
					setToggleSkywardSearchInputBox(!toggleSkywardSearchInputBox)
				}} className={classes.socialIconButtons}>
					{!isSkywardLoading ?
						<Image
							src="https://cdn.youscience.com/public/isp/social_icons/skyward.png"
							ariaLabel=""
							className={classes.socialIconImages}
						/> : <Button
							key={"SkywardBtn"}
							style={{ borderRadius: 10, border: 0, height: "80%" }}
							isFullWidth="true"
							isLoading={isSkywardLoading}
						></Button>}

				</div>)
			if (!employerView && IdP === "GADOE" && providers.indexOf("GADOE") != -1)
				return (<div key={IdP} onClick={async () => await handleIdPLogin(IdP)} className={classes.socialIconButtons}>
					<Image
						src="https://cdn.youscience.com/public/isp/social_icons/gadoe.png"
						ariaLabel=""
						className={classes.socialIconImages}
					/>
				</div>)
			if (!employerView && IdP === "GG4L" && providers.indexOf("GG4L") != -1)
				return (<div key={IdP} onClick={async () => await handleIdPLogin(IdP)} className={classes.socialIconButtons}>
					<Image
						src="https://cdn.youscience.com/public/isp/social_icons/gg4l.png"
						ariaLabel=""
						className={classes.socialIconImages}
					/>
				</div>)
		});
	}

	const [activationToken] = React.useState(sessionStorage.getItem("activationToken") || '');


	React.useEffect(() => {
		const div = document.querySelector('.amplify-alert__body')
		if (div && error && error.includes("UserMigration failed with error ")) {
			div.innerHTML = error.replace("UserMigration failed with error ", "");
		}
		if (div && error && error.includes("PreSignUp failed with error ")) {
			div.innerHTML = error.replace("PreSignUp failed with error ", "");
		}
	}, [error])

	React.useEffect(() => {
		if (props.isLinkAccountFlow) {
			const div = document.querySelector('body')
			if (div) div.style.background = Branding.white;
		}
		else {
			const div = document.querySelector('body')
			if (div) div.style.background = Branding.body;
		}
		if (sessionStorage.getItem("authorize") || sessionStorage.getItem("showLoginLoader")) {
			setProviderLogin(true);
			if (sessionStorage.getItem("showLoginLoader"))
				sessionStorage.removeItem("showLoginLoader");
			if (sessionStorage.getItem("authorize")) {
				let delayTime = +(config.ssoLoginWaitTime.common || 3400);
				if (config.ssoLoginWaitTime && sessionStorage.getItem("authorize")) {
					if (sessionStorage.getItem("authorize").toLowerCase().includes("clever") && (+config.ssoLoginWaitTime.clever > 0))
						delayTime = +config.ssoLoginWaitTime.clever;
					if (sessionStorage.getItem("authorize").toLowerCase().includes("classlink") && (+config.ssoLoginWaitTime.classlink > 0))
						delayTime = +config.ssoLoginWaitTime.classlink;
					if (sessionStorage.getItem("authorize").toLowerCase().includes("gadoe") && (+config.ssoLoginWaitTime.gadoe > 0))
						delayTime = +config.ssoLoginWaitTime.gadoe;
					if (sessionStorage.getItem("authorize").toLowerCase().includes("gg4l") && (+config.ssoLoginWaitTime.gg4l > 0))
						delayTime = +config.ssoLoginWaitTime.gg4l;
				}

				async function federatedSignInWithWaitingRoom() {
					await handleWaitingRoomAndLogin(async (waitingRoomRequest) => {
						setTimeout(() => {
							if (sessionStorage.getItem('authorize') && window.location.pathname != '/logout') {
								let authorizeUri = sessionStorage.getItem('authorize');
								let params = new URLSearchParams(authorizeUri.split('?')[1]);
								sessionStorage.removeItem('authorize');
								checkoutFromWaitingRoom(waitingRoomRequest);
								Auth.federatedSignIn({ provider: params.get('identity_provider') });
							}
						}, delayTime);
					});
				}
				federatedSignInWithWaitingRoom();
			}
		}
		getFormElements();
		toggleSignInSignUpButtonText();
	})
	React.useEffect(() => {
		// if (!isEmployerView.current) {
		checkIfMetaData(true);
		// }
	}, [])


	React.useEffect(() => {
		var initialValidate = async () => {
			try {

				setIsLoading(true)
				let result = await verifyActivationCode(activationToken);

				if (result && result.sso_provider && result.sso_provider === "Clever" && result.sso_district_id) {
					window.location = `${config.cleverInstantLinkUrl}?client_id=${config.cleverClientId}&district_id=${result.sso_district_id}`
					return;
				}
				if (result && result.sso_provider && result.sso_provider === "Google") {
					handleIdPLogin("Google");
					return;
				}
				if (result && result.sso_provider && result.sso_provider === "ClassLink") {
					handleIdPLogin("ClassLink");
					return;
				}
				setIsLoading(false);
			} catch (excep) {
				setIsLoading(false);
			}
		}
		if ((activationToken && location.pathname === "/sign_up") || (activationToken && props.initialAuthState === "signUp")) {
			initialValidate();
			return;
		}

	}, [activationToken])

	const handleTOSClick = (event) => {
		isToSAgreed.current = event.target.value;
		isToSAgreed.status = event.target.checked;
		isToSAgreed.tos_version = props?.tos?._id;
	}

	const handleOnChangePasswordSuccess = () => {
		navigate("/", { replace: true });
		setChangePasswordSuccess(true);
	}
	const handleIdPLogin = async (identity_provider) => {
		setIsLoading(true);
		return await handleWaitingRoomAndLogin(async (waitingRoomRequest) => {
			setTimeout(async () => {
				// Store redirect_uri/authorization_code in local storage to be used to later
				let queryStringParams = new URLSearchParams(window.location.search);
				let redirect_uri = queryStringParams.get('redirect_uri');
				let authorization_code = queryStringParams.get('authorization_code');
				let clientState = queryStringParams.get('state');
				if (redirect_uri) {
					localStorage.setItem(`client-redirect-uri`, redirect_uri);
				}
				if (authorization_code) {
					localStorage.setItem(`authorization_code`, authorization_code);
				}
				if (clientState) {
					localStorage.setItem(`client-state`, clientState);
				}
				checkIfMetaData(false);
				let customState = '';
				if (identity_provider.toLowerCase() === 'google' && decryptedData)
					customState = JSON.stringify({ 'custom:metadata': decryptedData });
				await Auth.federatedSignIn({ provider: identity_provider, customState: customState });
				checkoutFromWaitingRoom(waitingRoomRequest);
			}, 100);
		});
	}
	const handleIdpLoginActionDoNothing = async (client_id) => {
		return await handleWaitingRoomAndLogin((waitingRoomRequest) => {
			setTimeout(async () => {
				checkoutFromWaitingRoom(waitingRoomRequest);
			}, 1);
		});
	};

	const formatResult = (item) => {
		return (
			<Typography color="secondary" style={{ padding: "10px 0px", fontSize: "14px", color: "black" }}>
				{item.displayName}
			</Typography>
		);
	}

	const SwitchLogins = (
		<div style={{ marginTop: "30px" }}>
			<Typography>
				<Link
					onClick={toggleEmployerView}
					className={classes.link}
				>
					{!employerView ? `For employers` : `For schools and student`} &nbsp; <i style={{ verticalAlign: "middle" }} className="fa-solid fa-angle-right"></i>
				</Link>
			</Typography>
		</div>
	)
	const headerComponent = (titleText, className) => {
		return (
			!props.isLinkAccountFlow ?
				<>
					<div className={`${classes.headerText + ' ' + className}`}> {titleText}</div>
				</> :
				<div style={{ paddingTop: theme.spacing(0) }}> </div>
		)
	}

	const handleSignInSignUpClickEvent = async () => {
		setTimeout(() => {
			getFormElements();
			toggleSignInSignUpButtonText();
		}, 300);
	}


	const checkoutFromWaitingRoom = async (waitingRoomRequest) => {
		if (!awsconfig.waitingRoomEnabled) {
			return
		}
		try {
		const requestOptions = {
			method: 'POST',
			headers: {
			'Content-Type': 'application/json',
			},
			body: JSON.stringify({ event_id: awsconfig.waitingRoomEventId, request_id: waitingRoomRequest.apiRequestId }),
		};

		const generateTokenResponse = await fetch(`${awsconfig.waitingRoomPublicUrl}/generate_token`, requestOptions);
		if (!generateTokenResponse.ok) {
			console.log('Error on generate token' + generateTokenResponse);
		}
		} catch (error) {
			console.log('Error on checkout from waiting room' + error);
		}
  };

	const handleWaitingRoomAndLogin = async (callback) => {
		if (!awsconfig.waitingRoomEnabled) {
			return callback();
		}
		return new Promise(async (resolve, reject) => {
			try {
				const queueRequest = await assignOnQueue();
				const queueNumberResponse = await assignOnQueuePosition(queueRequest.api_request_id);
				await waitOnWaitingRoom(queueRequest.api_request_id, queueNumberResponse.queue_number);
				return resolve(callback({ apiRequestId: queueRequest.api_request_id }));
			} catch (error) {
				console.log('Error on waiting room' + error);
				return resolve(callback({ apiRequestId: undefined }));
			}
		});
	};

	const assignOnQueue = async () => {
		const requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ event_id: awsconfig.waitingRoomEventId }),
		};
		const queueNumberResponse = await fetch(`${awsconfig.waitingRoomPublicUrl}/assign_queue_num`, requestOptions);
		if (!queueNumberResponse.ok) {
			return;
		}
		return await queueNumberResponse.json();
	};

	const assignOnQueuePosition = async (request_id) => {
		const queuePositionResponse = await fetch(
			`${awsconfig.waitingRoomPublicUrl}/queue_num?event_id=${awsconfig.waitingRoomEventId}&request_id=${request_id}`
		);
		if (!queuePositionResponse.ok) {
			await new Promise(resolve => setTimeout(resolve, 1000));
			return await assignOnQueuePosition(request_id); // Check again after 1 seconds
		}
		return await queuePositionResponse.json();
	};

	const waitOnWaitingRoom = async (request_id, queue_number) => {
		const servingCounterResponse = await fetch(
			`${awsconfig.waitingRoomPublicUrl}/serving_num?event_id=${awsconfig.waitingRoomEventId}`
		);
		const servingCounter = await servingCounterResponse.json();

		const serviceCounterValue = parseInt(servingCounter.serving_counter)

		if (serviceCounterValue === 0 || servingCounter.serving_counter === undefined 
			|| queue_number === undefined || queue_number <= serviceCounterValue) {
			setShowWaitingRoom(false);
			return;
		} else {
			setIsLoading(false);
			let waitTime = Math.abs(queue_number / servingCounter.serving_counter);
			waitTime = Math.floor(waitTime) > 1 ? Math.floor(waitTime) : 1;
			sessionStorage.setItem("waitingRoomWaitingTime", waitTime);
			setShowWaitingRoom(true);
			await new Promise(resolve => setTimeout(resolve, 5000));
			await waitOnWaitingRoom(request_id, queue_number); // Check again after 5 seconds
			setShowWaitingRoom(false);
		}
	};

	
	const components = {

		VerifyUser: {
			Header() {
				return headerComponent("Verify Your Account", `${classes.helpTextHeaderText}`);
			},
		},
		ConfirmVerifyUser: {
			Header() {
				return headerComponent("Verify Your Account", `${classes.helpTextHeaderText}`);
			}
		},
		SignIn: {
			Header() {
				const text = employerView ? "Workforce login" : "Log in"
				return headerComponent(text, 'social-box')
			},
			Footer() {
				const { toResetPassword, toSignUp } = useAuthenticator();
				return props.isLinkAccountFlow ?
					<div style={{ paddingBottom: theme.spacing(3) }}> </div>
					:
					(
						<Grid className={"social-box"}>
							<div style={{ justifyContent: 'left', textAlign: "center" }}>
								<Typography>
									<Link
										onClick={toResetPassword}
										className={classes.link}
									>
										Forgot your password?
									</Link>
								</Typography>
								<Typography style={{ justifyContent: 'center', textAlign: "center" }}>
									<span className={classes.subTitle}> New to YouScience? </span>
									<Link
										onClick={() => { toSignUp(); handleSignInSignUpClickEvent(); }}
										className={classes.link}
									>
										Create an account
									</Link>
								</Typography>

							</div>
							{config.enableEmployerPage ? SwitchLogins : null}
						</Grid >
					);
			}
		},
		SignUp: {
			Header() {
				const text = employerView ? "Workforce signup" : "Sign up"
				return headerComponent(text, 'social-box');
			},
			Footer() {
				const { toSignIn } = useAuthenticator();

				return (
					<>
						<Grid container style={{ justifyContent: 'center' }} className={classes.grid}>

							<div >
								<Typography style={{ justifyContent: 'center', textAlign: "center" }}>
									<span className={classes.subTitle}> Already have an account? </span>
									<Link
										onClick={() => { toSignIn(); handleSignInSignUpClickEvent(); }}
										className={classes.link}
									>
										Log in
									</Link>

								</Typography>
							</div>

						</Grid>
						{config.enableEmployerPage ?
							<div style={{ paddingLeft: "30px" }}> {SwitchLogins} </div>
							: null}

					</>
				);
			},
			FormFields() {
				const { validationErrors } = useAuthenticator();
				const passwordFieldWarning = (function (validationErrors) {
					return (validationErrors['password_suggestion']) ?
						<div className={classes.validationBox}>
							Your password must contain
							<div className={`${validationErrors.password_suggestion?.password_error_1 ? classes.passwordError : ''}`}>
								<i className={`fa-solid ${validationErrors.password_suggestion?.password_error_1 ? 'fa-times-circle ' + classes.passwordError : 'fa-circle-check ' + classes.passwordSuccess}`}></i>&nbsp;At least 8 characters</div>
							<div className={`${validationErrors.password_suggestion?.password_error_2 ? classes.passwordError : ''}`}>
								<i className={`fa-solid ${validationErrors.password_suggestion?.password_error_2 ? 'fa-times-circle ' + classes.passwordError : 'fa-circle-check ' + classes.passwordSuccess}`}></i>&nbsp;At least 1 number</div>
							<div className={`${validationErrors.password_suggestion?.password_error_3 ? classes.passwordError : ''}`}>
								<i className={`fa-solid ${validationErrors.password_suggestion?.password_error_3 ? 'fa-times-circle ' + classes.passwordError : 'fa-circle-check ' + classes.passwordSuccess}`}></i>&nbsp;At least 1 special character (e.g !@#%$, etc)</div>
							<div className={`${validationErrors.password_suggestion?.password_error_4 ? classes.passwordError : ''}`}>
								<i className={`fa-solid ${validationErrors.password_suggestion?.password_error_4 ? 'fa-times-circle ' + classes.passwordError : 'fa-circle-check ' + classes.passwordSuccess}`}></i>&nbsp;Upper and lowercase letter</div>
						</div> : null
				})(validationErrors);
				//injecting html code below create password field
				validationErrors['password'] = passwordFieldWarning;
				return (
					<>
						<Authenticator.SignUp.FormFields />
						{
							!props.isLinkAccountFlow ?
								<CheckboxField
									errorMessage={validationErrors["custom:tos_signed"]}
									hasError={!!validationErrors["custom:tos_signed"]}
									name="custom:tos_signed"
									onChange={handleTOSClick}
									checked={isToSAgreed.status && !validationErrors["custom:tos_signed"] ? true : false}
									value={true}
									label={
										<Typography style={{ fontSize: "12px" }}>
											I agree to the
											<a style={{ marginLeft: theme.spacing(0.5) }} href={props?.tos?.url || "https://www.youscience.com/terms-of-service/"}
												target="_blank" className={classes.linkTos}>Terms of Service
											</a>
										</Typography>
									}
								/>
								:
								null
						}
					</>
				);
			}
		},
		ResetPassword: {
			Header() {
				return headerComponent("Reset Password", "");
			}
		},
		NewPasswordField: (props) => (
			<AccountSettings.ChangePassword.NewPasswordField
				{...props}
				style={{ minWidth: "250px" }}
			/>
		),
		ConfirmPasswordField: (props) => (
			<AccountSettings.ChangePassword.ConfirmPasswordField
				{...props}
				style={{ minWidth: "250px" }}
			/>
		),
		CurrentPasswordField: (props) => (
			<AccountSettings.ChangePassword.CurrentPasswordField
				{...props}
				style={{ minWidth: "250px" }}
			/>
		),
		ConfirmResetPassword: {
			Footer() {
				const { tokens } = useTheme();
				const { toSignIn } = useAuthenticator();
				return (
					<div
						style={{ alignSelf: "center", color: "red", fontWeight: "500", fontSize: "14px" }}
						padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
					>
						<button style={{ marginLeft: theme.spacing(0.5) }} onClick={toSignIn} className={["amplify-button amplify-field-group__control amplify-button--link amplify-button--small"]}>Back to Sign In
						</button>

					</div>
				);
			}
		}
	};
	const services = {
		async handleSignUp(formData) {
			let { username, password, attributes } = formData;
			attributes.email = attributes.email.toLowerCase();
			username = username && username.toLowerCase();
			attributes.locale = props.lang;
			attributes['custom:tos_version'] = isToSAgreed.tos_version;
			checkIfMetaData(false);
			if (decryptedData) {
				attributes['custom:metadata'] = decryptedData;
			}
			try {
				await handleWaitingRoomAndLogin(async (waitingRoomRequest) => {
					await checkoutFromWaitingRoom(waitingRoomRequest);
				});
				return Auth.signUp({
					username,
					password,
					attributes,
					clientMetadata: {
						authFlow: 'SignUp',
						password: password,
					},
					autoSignIn: {
						enabled: true,
					},
				}).catch((e) => {
					if (formData?.attributes['email']) formFields.signUp.email.defaultValue = formData.attributes['email'];
					if (password) {
						formFields.signUp.password.defaultValue = password;
						formFields.signUp.confirm_password = { defaultValue: password };
					}
					if (formData?.attributes['custom:alternate_email'])
						formFields.signUp['custom:alternate_email'].defaultValue = formData.attributes['custom:alternate_email'];
					if (e.message?.includes('PreSignUp failed with error Email id already exists') == true)
						throw new Error('Email has already been taken. You can sign in, or reset your password.');
					throw e;
				});
			} catch (e) {
				console.log('Error on signup');
			}
		},
		

		async handleSignIn(data) {
			if (data.username) {
				data.username = data.username.toLowerCase().trim();
			}
			return await handleWaitingRoomAndLogin(async (waitingRoomRequest) => {
				await checkoutFromWaitingRoom(waitingRoomRequest);
				try {
					const loggedInUser = await Auth.signIn(data, undefined, { email: data.username, password: data.password });

					if (!loggedInUser.signInUserSession) {
						// User is partially signed in and may need further verification, such as MFA.
						return loggedInUser;
					}

					// User is fully signed in; now check if MFA is configured
					// Return the user if MFA is not required, not preferred, or recently verified.
					// Otherwise, forget the device and re-sign in to verify MFA, possibly due to a new device or expired verification.

					const { idToken } = loggedInUser.signInUserSession;
					const mfaRequired = idToken?.payload?.mfaRequired;
					const mfaValidityPeriod = 1000 * 60 * 60 * 24 * awsconfig.mfaValidityDays; // Configured days in milliseconds
					const mfaLastVerifiedAt = idToken?.payload?.mfaLastVerifiedAt || Date.now() - mfaValidityPeriod - 60000; // 1 minute before the validity if user's last verification flag is not set to force the mfa verification

					if (!mfaRequired || loggedInUser.preferredMFA === "NO_MFA" || mfaLastVerifiedAt >= Date.now() - mfaValidityPeriod) {
						return loggedInUser;
					}

					await Auth.forgetDevice();
					// Re-sign in to get a new session and verify MFA
					return await Auth.signIn(data, undefined, { email: data.username, password: data.password });

				} catch (signInError) {
					if (signInError.message?.includes('User migrated successfully')) {
						// User has been migrated to a new user pool. Sign in again to get a new session.
						return await Auth.signIn(data, undefined, { email: data.username, password: data.password });
					}
					throw new Error("Incorrect username or password");
				}
			});
		},

		
		async handleForgotPassword(formData) {
			return Auth.forgotPassword(formData, { authFlow: 'ForgotPassword', password: formData.password });
		},
		async handleForgotPasswordSubmit(formData) {
			return Auth.forgotPasswordSubmit(formData.username, formData.code, formData.password, {
				authFlow: 'ForgotPasswordSubmit',
				password: formData.password,
			});
		},

		async validateCustomSignUp(formData) {
			const lowerCaseRegex = new RegExp('^(?=.*[a-z]).+$');
			const upperCaseRegex = new RegExp('^(?=.*[A-Z]).+$');
			const numberCaseRegex = new RegExp('^(?=.*\\d).+$');
			const specialCharRegex = new RegExp('^(?=.*[-+_!@#$%^&*.,?]).+$');
			const validEmailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/);
			let errorObj = {};
			let validationErrors = {};
			if (!formData['custom:tos_signed'])
				validationErrors['custom:tos_signed'] = 'You must agree to the Terms of Service';
			if (formData['email'] && !validEmailRegex.test(formData['email'])) {
				validationErrors['email'] = 'Your email is invalid, Please provide a valid email';
			}
			if (formData['password']) {
				if (formData['password']?.length >= 0 && formData['password']?.length < 8) {
					errorObj['password_error_1'] = true;
				}
				if (!numberCaseRegex.test(formData['password'])) {
					errorObj['password_error_2'] = true;
				}
				if (!specialCharRegex.test(formData['password'])) {
					errorObj['password_error_3'] = true;
				}
				if (!lowerCaseRegex.test(formData['password']) || !upperCaseRegex.test(formData['password'])) {
					errorObj['password_error_4'] = true;
				}
				if (
					errorObj['password_error_1'] ||
					errorObj['password_error_2'] ||
					errorObj['password_error_3'] ||
					errorObj['password_error_4']
				) {
					validationErrors['password_suggestion'] = errorObj;
				}
			}
			if (!validationErrors['custom:tos_signed']) {
				if (formData['email'] && !formData['password']) {
					validationErrors['password'] = 'Password cannot be empty';
				}
				if (formData['password'] && !formData['confirm_password']) {
					validationErrors['confirm_password'] = 'Repeat password cannot be empty';
				}
			}
			if (formData['custom:alternate_email'] && formData['custom:alternate_email'] === signup_email)
				validationErrors['custom:alternate_email'] = 'Email and Alternate Email should not be same';

			if (Object.keys(validationErrors).length > 0) return validationErrors;
		},
	};

	if (isLoading || sessionStorage.getItem("isResetPasswordFlow") || props.initialAuthState === "resetPsssword") {
		return <SpinnerPage />
	}
	if (showWaitingRoom) {
		return <WaitingRoom />;
	}

	if (props.isLinkAccountFlow && route === "authenticated" && user) {
		return <RedirectPage to={config.brightPathUrl} />
	}
	if (changePasswordSuccess) {
		return <RedirectPage to={config.brightPathUrl} />
	}
	const CustomToolTip = withStyles((theme) => ({
		arrow: {
			color: '#252C3A'
		},
			tooltip: {
				backgroundColor: '#252C3A',
				color: '#ffffff',
				minWidth: 205,
				fontWeight: 400,
				fontSize: theme.typography.pxToRem(10),
				border: '1px solid #252C3A',
			},
	}))(Tooltip);

	return (
		<div className={classes.rootContainer}>
			{isProviderLogin
				?
				<Grid container
					direction="column"
					alignItems="center"
					justifyContent="center"
					style={{ marginTop: "20%" }}>
					<CircularProgress variant='indeterminate' thickness={3} size={"3em"} />
					{
						<Typography style={{
							marginBottom: "2em",
							fontWeight: 'bold',
							marginTop: "2em",
							fontSize: "12px",
							color: Branding.primary
						}}>Please wait...</Typography>
					}
				</Grid>
				: null}

			{
				!props.isLinkAccountFlow && !isProviderLogin
					?
					<Grid
						container
						spacing={0}
						direction="column"
						alignItems="center"
						justifyContent="center"
						className={MobileView ? classes.rootGridMobile : classes.rootGrid}>
					</Grid>
					:
					null
			}

			{!isProviderLogin && (
				<Grid container justifyContent="center">

					<Grid xs={12} md={5} lg={4} sm={6} item={true} className={classes.grid} style={{ backgroundColor: "white", paddingBottom: "16px" }}>
						<div style={{ padding: "3em 3em 0em 3em" }}>
							<CardMedia
								className={classes.cardMedia}
								image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
								title={Branding.appName} />
						</div>
						{props.initialAuthState === "changePassword" ?
							<Card style={{ padding: "1em 4em" }} elevation={0}>
								<CardContent style={{ padding: props.isLinkAccountFlow ? "0px" : "16px" }} className={classes.cardContent}>
									<AccountSettings.ChangePassword components={components} onSuccess={handleOnChangePasswordSuccess} />
								</CardContent>
							</Card >
							:
							<Card elevation={0}>
								<CardContent className={classes.cardContent}>
									<Authenticator services={services} formFields={formFields} components={components} initialState={props.initialAuthState} loginMechanisms={["email"]} socialProviders={[]}>
									</Authenticator>
								</CardContent>
							</Card >
						}
					</Grid>
					<Grid item={true} xs={12} md={5} lg={employerView ? 5 : 4} sm={6} container className={classes.grid} style={{ justifyContent: 'center', alignItems: "center", background: "white" }}>
						<Card elevation={0} style={{ paddingBottom: "16px" }}>
							<CardContent className={classes.cardContent}>
								<div className={'social-box'}>
									{!employerView ?
										<div>
											<div>
												<div className={`${classes.helpTextHeaderText}`}>
													Log in with your school's SIS&nbsp;
													<CustomToolTip placement='top' title='If your school uses Clever or ClassLink, click from the following icons to be redirected to the appropriate login screen. Once logged in, select the YouScience app to get started.' arrow ><Help className={`${classes.helpIcon}`} /></CustomToolTip>
												</div>
											</div>
											{toggleSkywardSearchInputBox ?
												<div className={"search-input"} style={{ marginTop: "16px" }}>
													<ReactSearchAutocomplete
														items={skywardClients || []}
														onSelect={async (item) => {
															if (!item) return;
															setToggleSkywardSearchInputBox(false);
															setIsSkywardLoading(true);
															await handleIdPLogin(item.providerName)
														}}
														showClear={false}
														showIcon={true}
														placeholder={"Search for your school or district."}
														fuseOptions={
															{
																keys: ["providerName", "displayName"],
																shouldSort: true
															}
														}
														styling={{
															boxShadow: "none",
															hoverBackgroundColor: "#fafbfc",
															fontSize: "14px",
															fontFamily: "Courier",
															lineColor: "#41c8c3",
															clearIconMargin: "3px 8px 0 0",
															borderRadius: "2px",
															boxShadow: "none",
														}}
														autoFocus
														resultStringKeyName="displayName"
														formatResult={formatResult}
													/>
												</div>
												: null}
											<Flex className={classes.socialIconsRoot} style={{ paddingTop: "16px" }}>
												{oidcProviders.length > 0 && (
													generateOIDCButtons(oidcProviders.filter((idp) => (idp.toLowerCase() == 'clever' || idp.toLowerCase() == 'classlink' || idp.toLowerCase() == 'skyward')))
												)}
											</Flex>
										</div>
										: null}
									<div>
										{employerView ? (
											<Box className={classes.employerSigninContainer}>
												<Divider className={classes.horizontalDivider} />
												<Typography variant="body1" className={classes.headingText} >
													Or continue with Single Sign On
												</Typography>
												<Divider className={classes.horizontalDivider} />
											</Box>
										) : (
											<div className={`${classes.helpTextHeaderText}`}>
												Log in with Single Sign On&nbsp;
												<CustomToolTip
													arrow
													placement="top"
													title={"If your school uses Google, Microsoft, or GA SLDS to login, please choose from the following icons."
													}
												>
													<Help className={`${classes.helpIcon}`} />
												</CustomToolTip>
											</div>
										)}
									</div>
									{toggleSearchInputBox ?
										<div className={"search-input"} style={{ marginTop: "16px" }}>
											<ReactSearchAutocomplete
												items={office365Clients || []}
												onSelect={async (item) => {
													if (!item) return;
													setToggleSearchInputBox(false);
													setIsOffice365Loading(true);
													await handleIdPLogin(item.providerName)
												}}
												showClear={false}
												showIcon={true}
												placeholder={"Search for your school or district."}
												fuseOptions={
													{
														keys: ["providerName", "displayName"],
														shouldSort: true
													}
												}
												styling={{
													boxShadow: "none",
													hoverBackgroundColor: "#fafbfc",
													fontSize: "14px",
													fontFamily: "Courier",
													lineColor: "#41c8c3",
													clearIconMargin: "3px 8px 0 0",
													borderRadius: "2px",
													boxShadow: "none",
												}}
												autoFocus
												resultStringKeyName="displayName"
												formatResult={formatResult}
											/>
										</div>
										: null}
									<Flex className={classes.socialIconsRoot} style={{ paddingTop: "16px" }}>
										{oidcProviders.length > 0 && (
											generateOIDCButtons(oidcProviders.filter((idp) => (idp.toLowerCase() == 'google' || idp.toLowerCase() == 'office365' || idp.toLowerCase() == 'gadoe' || idp.toLowerCase() == 'gg4l')))
										)}
									</Flex>

								</div>
							</CardContent>
							<EmployersOptions employerView={employerView} classes={classes} />
						</Card>
					</Grid>
				</Grid>
			)}
			{!props.isLinkAccountFlow && (
				<Footer></Footer>
			)}

			{snackBarOps && snackBarOps.open && (
				<AppSnackbar ops={snackBarOps} />
			)}
		</div >
	);
}

export default connect(mapStateToProps)(SignInContainer);
